export default __webpack_public_path__ + "static/media/saadat.0a2f3233.png";